module.exports = __webpack_public_path__ + "img/barter-full.2bb364be.png";